import { CATALOGUE } from "../../config/catalogue";
import { ModelCard } from "./ModelCard";
import { MoreSports } from "./MoreSports";
import styles from "./ModelGrid.module.css";

interface Props {
  /** Directory links into the chat; the landing page just shows state. */
  linkTo?: (id: string) => string;
}

/**
 * The full sport × mode grid — every cell, including the ones that aren't built
 * and the one that never will be. Eight since football was added on 2026-08-28;
 * it was six before, and the count is deliberately not written down anywhere
 * that renders.
 *
 * Rendering the whole grid is deliberate. A grid with holes in it reads as a
 * bug; "Not planned", said out loud, reads as accountable — which is the brand.
 *
 * ⚠️ SIX OF EIGHT CELLS NOW SAY "COMING SOON", which is a ratio worth watching
 * rather than a bug to fix. The grid is honest at any ratio, but a page that is
 * mostly promises reads differently from one that is mostly product — if a
 * fourth code lands before a third model does, that is the moment to ask
 * whether this belongs on the LANDING page or only in the directory.
 *
 * The derived "2 answering questions / 3 coming soon / 1 not planned" summary
 * that sat above the grid was removed on 2026-08-06 (Ned). Each card already
 * carries its own badge, so the strip restated the grid as a scoreboard — and
 * the number it led with was the count of things that DON'T work yet. The cards
 * still say exactly the same thing, one at a time, without totalling it up.
 */
export function ModelGrid({ linkTo }: Props) {
  return (
    <div className={styles.grid}>
      {CATALOGUE.map((model) => (
        <div key={model.id} className={styles.cell}>
          <ModelCard model={model} to={linkTo?.(model.id)} />
        </div>
      ))}
      {/* Ninth cell, and not a model. Eight models across a 3-wide grid left the
          bottom-right corner empty, which reads as the page having failed to
          finish rather than as a deliberate shape. It is LAST rather than
          positioned: at 980px the grid drops to two columns and at 620px to
          one, so "bottom right" is only true on a wide screen, and anything
          pinned there with grid-column would land mid-grid on a phone. */}
      <div className={styles.cell}>
        <MoreSports />
      </div>
    </div>
  );
}
